import React from 'react';
import renderer from 'react-test-renderer';
import '@testing-library/jest-dom';
import {
  fireEvent, render, screen, waitFor,
} from '@testing-library/react';
import { account, user } from '../../__mocks__/account-data';

import MoveToAccountSidebar from '../../../admin/users/MoveToAccountSidebar';
import api from '../../../../services/api';

global.fetch = jest.fn().mockResolvedValueOnce({ json: () => Promise.resolve({ }) });
api.admin.users.update = jest.fn().mockResolvedValue({ status: 'OK' });

it('renders correctly with props', () => {
  const tree = renderer.create(
    <MoveToAccountSidebar
      user={{ ...user, account }}
      onClose={() => {}}
      onUpdated={() => {}}
    />,
  ).toJSON();
  expect(tree).toMatchSnapshot();
});

it('renders correctly without props', () => {
  const tree = renderer.create(<MoveToAccountSidebar />).toJSON();
  expect(tree).toMatchSnapshot();
});

it('close and update events with status ok', async () => {
  const close = jest.fn();
  const update = jest.fn();
  render(
    <MoveToAccountSidebar
      user={{ ...user, account }}
      onClose={close}
      onUpdated={update}
    />,
  );

  const closeButton = await screen.getByTestId('close-move-section');
  const updateButton = await screen.getByText('Update');
  expect(closeButton).toBeInTheDocument();
  expect(updateButton).toBeInTheDocument();
  fireEvent.click(closeButton);
  expect(close).toBeCalledTimes(1);

  fireEvent.click(updateButton);
  await waitFor(() => expect(update).toBeCalledTimes(1));
});
